import React, { useState, useEffect } from "react";
import CustomTable from "../../../../customComponents/CustomTable";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DownloadSVG from "./../../../../../Assets/icons/DownloadIconMIS.svg";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import { TABLE_HEADERS, keyMapping } from "../../../../../constants/Taxes";
import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../../customComponents/CustomLoader";
import { FiDownload } from "react-icons/fi";


const TaxesList = () => {
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({});
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [totalInactive, setTotalInactive] = useState(0)
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchTaxesData(newPage);
  };
  const fetchTaxesData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        "/tax/list",
        {
          "orderBy": "taxes_id desc",
          page,
          pageSize,
          searchText: searchTerm
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      setTableData(formattedData);
      //toastSuccess("Product Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching taxes list:", error);
    }
    finally {
      setLoading(false)
    }
  };
  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      orderBy: "",
    };

    try {
      const response = await axiosInstance.post("/tax/tax-report-excel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "taxes.csv";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  const handleEditButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITTAXES}`, { state: { data: rowData } });
    console.log("rowdata", rowData)
  }
  useEffect(() => {
    if (searchTerm === "") {
      fetchTaxesData();
    }
  }, [searchTerm]);
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="OnboardManagamentContainer">
            <div className="OnboardManagamentbuttonContainer">
              <h5>Taxes</h5>
            </div>

            <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
              <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                <h5 className="listTopDataValueText" >{totalData} </h5>
                <h6>All Taxes</h6>
              </div>
              <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                <h5 className="listTopDataValueText" >{totalActive} </h5>
                <h6>Active Taxes</h6>
              </div>
              <div className='topleftdataContainer'>
                <h5 className="listTopDataValueText" >{totalInactive} </h5>
                <h6>Inactive Taxes</h6>
              </div>
              <button
                className="addcustomerbutton"
                onClick={() => navigate(ROUTES_NAVIGATION.TAXES_ADD)}
              >
                Add Taxes
              </button>
            </div>
          </div>

          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className='listsearchContainer'>
                <h5>Tax List</h5>
                <div>
                  <SearchInput
                    placeholder="Search Tax"
                    onSearch={fetchTaxesData}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                 <div
                                onClick={downloadExcel}
                                  className="flte-btnnn"
                                  style={{ borderRadius: "38px",cursor: "pointer"}}
                                >
                                  Export
                                  <span>
                                  {/* <img
                                    onClick={downloadExcel}
                                    src={DownloadSVG}
                                    alt="downloadSvg"
                                    className="downloadexcel-misreportsales"
                                    style={{
                                      // paddingTop: "9rem",
                                      // paddingRight: "1rem",
                                      
                                      cursor: "pointer",
                                      height:"24px"
                                    }}
                                  /> */}
                                  <FiDownload   className="downloadexcel-misreportsales" style={{cursor:"pointer"}} size={22} />
                                  </span>
                                </div>
 
              </div>
            </div>

            <CustomTable
              data={tableData}
              headers={TABLE_HEADERS}
              keyMapping={keyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEditButton}
              totalRecords={totalRecords}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TaxesList;
